import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import {
    ACCOUNT_SETTING_FORM_SUBMITTED,
    FETCH_HOO_SETTINGS_SUCCESS,
    MIB_TOGGLE_LOCATIONS_MODAL,
    ON_SETTINGS_TERMINAL_PICKER_SUBMITTED,
    SETTING_FORM_SUBMITTED,
    SETTINGS_IMAGE_UPLOAD_MODAL_CONFIRM_CLICKED,
    SETTINGS_IMAGE_UPLOAD_MODAL_TOGGLE_CLICKED,
    SETTINGS_IMAGE_UPLOAD_RESET_DATA,
    SETTINGS_SAVE_ENDED,
    TERMINAL_SETTING_FORM_SUBMITTED,
} from "./actions"
import { DELETE_TERMINAL_CLICKED } from "../locations/actions"
import {
    DELIVERY_SETTINGS_SERVICE_SELECTED,
    FETCH_DELIVERY_SETTINGS_SUCCESS,
    UBER_DIRECT_GENERATE_ORGANIZATION_ID_FAILURE,
    UBER_DIRECT_GENERATE_ORGANIZATION_ID_REQUESTED,
    UBER_DIRECT_GENERATE_ORGANIZATION_ID_SUCCESS,
} from "./deliverySettings/actions"
import type { DeliverySettingsResponse, HooSettingsResponse } from "../../../graphql/types"

export type DeliverySettingsState = {
    selectedServiceId: Maybe<string>
    isGeneratingUberId: boolean
    data: Maybe<DeliverySettingsResponse>
}

export type SettingsState = {
    selectedTerminalIds: string[]
    isSaving: boolean
    mibModal: {
        mibModalOpened: boolean
        mibModalType: string
    }
    imageModalOpened: boolean
    fileToUpload: Maybe<string>
    deliverySettings: DeliverySettingsState

    hooSettings: Maybe<HooSettingsResponse>
}

export const createDefaultSettingsState = () => ({
    selectedTerminalIds: [],
    isSaving: false,
    mibModal: {
        mibModalOpened: false,
        mibModalType: "activate",
    },
    imageModalOpened: false,
    fileToUpload: null,
    deliverySettings: {
        selectedServiceId: null,
        isGeneratingUberId: false,
        data: null,
    },
    hooSettings: null,
})
export const settingsReducer = (state: Maybe<SettingsState> = undefined, action: Record<string, any>) => {
    if (!state) {
        return createDefaultSettingsState()
    }

    switch (action.type) {
        case SETTINGS_IMAGE_UPLOAD_MODAL_CONFIRM_CLICKED:
            return { ...state, imageModalOpened: false, fileToUpload: action.payload.file }

        case SETTINGS_IMAGE_UPLOAD_MODAL_TOGGLE_CLICKED:
            return { ...state, imageModalOpened: action.payload.opened, fileToUpload: action.payload.file }

        case SETTINGS_IMAGE_UPLOAD_RESET_DATA:
            return { ...state, imageModalOpened: false, fileToUpload: null }

        case ON_SETTINGS_TERMINAL_PICKER_SUBMITTED: {
            return { ...state, selectedTerminalIds: action.payload.terminalIds }
        }

        case DELETE_TERMINAL_CLICKED: {
            return {
                ...state,

                selectedTerminalIds: state.selectedTerminalIds.filter(id => id !== action.payload.terminalId),
            }
        }

        case TERMINAL_SETTING_FORM_SUBMITTED:
        case ACCOUNT_SETTING_FORM_SUBMITTED:
        case SETTING_FORM_SUBMITTED:
            return { ...state, isSaving: true }

        case SETTINGS_SAVE_ENDED:
            return { ...state, isSaving: false }

        case MIB_TOGGLE_LOCATIONS_MODAL:
            return {
                ...state,
                mibModal: {
                    mibModalOpened: action.payload.opened,
                    mibModalType: action.payload.type,
                },
            }

        case DELIVERY_SETTINGS_SERVICE_SELECTED:
            return {
                ...state,
                deliverySettings: { ...state.deliverySettings, selectedServiceId: action.payload.serviceId },
            }

        case FETCH_DELIVERY_SETTINGS_SUCCESS:
            return { ...state, deliverySettings: { ...state.deliverySettings, data: action.payload.data } }

        case UBER_DIRECT_GENERATE_ORGANIZATION_ID_REQUESTED:
            return {
                ...state,
                deliverySettings: {
                    ...state.deliverySettings,
                    isGeneratingUberId: true,
                },
            }

        case UBER_DIRECT_GENERATE_ORGANIZATION_ID_SUCCESS:
            return {
                ...state,
                deliverySettings: {
                    ...state.deliverySettings,
                    isGeneratingUberId: false,
                    data: {
                        ...state.deliverySettings.data,
                        deliveryPartners: {
                            ...state.deliverySettings.data?.deliveryPartners,
                            uberDirectOrganizationId: action.payload.id,
                            uberEnabled: true,
                        },
                    },
                },
            }

        case UBER_DIRECT_GENERATE_ORGANIZATION_ID_FAILURE:
            return {
                ...state,
                deliverySettings: {
                    ...state.deliverySettings,
                    isGeneratingUberId: false,
                },
            }

        case FETCH_HOO_SETTINGS_SUCCESS:
            return { ...state, hooSettings: action.payload.data }

        default:
            return state
    }
}
